module.exports = require('analytics-curry')('experiment.set.experiment.done');


//////////////////
// WEBPACK FOOTER
// ./~/@atlassiansox/experiment-devtools/lib/webpack/events-loader.js!?experiment.set.experiment.done
// module id = 36
// module chunks = 0